import { SparkleIcon } from "../components/icons";
import { useT } from "../i18n";

/**
 * AskButton is the way into the chat without choosing a line: a labelled pill
 * with the sparkle, the app's Modern Ask (mobile/lib/screens/reader_screen.dart
 * _AskButton). A bare speech-bubble icon in the corner was not read as the
 * book's best feature (owner, 10-23). Placed by its caller: floating at the end
 * edge, just above the transport where there is one.
 */
export default function AskButton({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) {
  const t = useT();
  return (
    <button
      type="button"
      data-testid="open-chat"
      aria-label={t.chat.title}
      onClick={onClick}
      // A sage ring, not the hairline: on a dark page a shadow does not show,
      // and a hairline one step off the ground sinks into it (the app's note).
      className={`z-20 inline-flex h-12 items-center gap-2 rounded-full border-[1.5px] border-sage/60 bg-surface ps-3.5 pe-[1.125rem] text-[0.9375rem] font-bold text-ink shadow-[0_3px_10px_-2px_rgb(0_0_0/0.25)] transition-colors hover:bg-sunk ${className}`}
    >
      <SparkleIcon className="size-[1.125rem] text-sage" />
      {t.chat.ask}
    </button>
  );
}
